// @flow

import React from "react";
import { compose, withHandlers } from "recompose";

import { LinkButton } from "@quantum/ui";

import { MoreOptionsIcon } from "../";

import { type AssetKey } from "../../../model";

import "./name-cell.css";

type Props = {
  assetKey: AssetKey,
  value: string,
  onOpenAssetMenu: (AssetKey, MouseEvent) => any,
};

type EnhancedProps = {
  onIconClick: (SyntheticMouseEvent<HTMLDivElement>) => any,
};

const enhance: any = compose(
  withHandlers({
    onIconClick: ({ assetKey, onOpenAssetMenu }) => event =>
      onOpenAssetMenu(assetKey, event.nativeEvent),
  })
);

const NameCell = ({ value, onIconClick }: Props & EnhancedProps) => (
  <div className="NameCell" onClick={onIconClick}>
    <div className="NameCell__icon">
      <MoreOptionsIcon />
    </div>
    <LinkButton className="NameCell__value">{value}</LinkButton>
  </div>
);

export default enhance(NameCell);
